// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__XEySn","loaderOuter":"PageOverlayLoader_loaderOuter__ODMgB"};